<template>
  <div class="DateFilter">
    <p class="DateFilter__Selected">
      {{ $t(`date-picker.${option}`) }}
    </p>
    <span class="DateFilter__Divider">|</span>
    <p class="DateFilter__Date">{{ startDate }} - {{ endDate }}</p>
    <Icon
      class="DateFilter__Toggler"
      name="keyboard-arrow-down"
      @click="toggleVisibility"
    />
    <div class="DateFilter__DatePicker" v-show="isVisible">
      <DatePicker :withToggler="withToggler" :option="option" />
    </div>
  </div>
</template>

<script>
import Icon from '../Icon.vue';

import formatDate from '@/utils/moment';
import EventBus from '@/utils/eventBus';

import DatePicker from '../DatePicker';

export default {
  name: 'DateFilter',
  components: {
    DatePicker,
    Icon,
  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    startDate() {
      return formatDate(this.date.start, 'DD/MM');
    },
    endDate() {
      return formatDate(this.date.end, 'DD/MM');
    },
  },
  methods: {
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },
  },
  mounted() {
    EventBus.$on('ON_DATE_APPLY', (date, selected) => {
      this.$emit('dateChange', { newDate: date, newOption: selected });
      this.toggleVisibility();
    });
  },
  destroyed() {
    EventBus.$off('ON_DATE_APPLY');
  },
  props: {
    option: {
      type: String,
      required: false,
    },
    date: {
      type: Object,
      required: true,
    },
    withToggler: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.DateFilter {
  align-items: center;
  color: $primary;
  display: flex;
  max-width: rem(290);
  position: relative;

  p {
    margin-bottom: rem(15);
  }

  &__Selected {
    font-size: rem(15);
    font-weight: 700;
  }

  &__Divider {
    margin: 0 rem(5);
  }

  &__Date {
    font-size: rem(15);
    width: rem(110);
  }

  &__DatePicker {
    position: absolute;
    right: 0;
    top: rem(40);
    z-index: 100;
  }

  &__Toggler {
    cursor: pointer;
    margin-left: rem(10);
    margin-right: rem(5);
  }
}
</style>
